export default __webpack_public_path__ + "static/media/andrei_krasovaky.d6ace14a.jpeg";